function isNextv (env = process.env) {
  return process.env.VUE_APP_SERVICE === 'nextv'
}

export const firebaseConfigTongtongpod = {
  apiKey: 'AIzaSyCtKPSoCz583mbY9Kx-FTOyidK4xhXmjn8',
  authDomain: 'tongtongpod-3556c.firebaseapp.com',
  databaseURL: 'https://tongtongpod-3556c.firebaseio.com',
  projectId: 'tongtongpod-3556c',
  storageBucket: 'tongtongpod-3556c.appspot.com',
  messagingSenderId: '772159453941'
}

export const firebaseConfigNextv = {
  apiKey: 'AIzaSyDmL5PNlH21fFq9CEvZ4snmftiOdwJXAZY',
  authDomain: 'tomato-ddbce.firebaseapp.com',
  databaseURL: 'https://tomato-ddbce.firebaseio.com',
  projectId: 'tomato-ddbce',
  storageBucket: 'tomato-ddbce.appspot.com',
  messagingSenderId: '378025922430'
}

export const firebaseConfig = (() => {
  return isNextv() ? firebaseConfigNextv : firebaseConfigTongtongpod
})()

export const firebaseDbUrlTongtongpod = {
  test: 'https://tongtongpod-3556c-test.firebaseio.com',
  quizBank: 'https://tongtongpod-3556c-quizbank.firebaseio.com'
}

export const firebaseDbUrlNextv = {
  test: 'https://tomato-ddbce-test.firebaseio.com/',
  quizBank: 'https://tomato-ddbce-quizbank.firebaseio.com/'
}

export const firebaseDbUrl = (() => {
  return isNextv() ? firebaseDbUrlNextv : firebaseDbUrlTongtongpod
})()

export const remonDefaultConfigTongtongpod = {
  credential: {
    key: '043ebf5d40a6d94428dfdb38b55c6cde637ab6b1be86b880',
    serviceId: 'minic77@etomato.com'
    // key: '1234567890',
    // serviceId: 'SERVICEID1',
    // key: 'testid',
    // serviceId: 'testid',
    // wsurl: 'ws://localhost:8081/ws',
    // resturl: 'http://localhost:8081/rest',
    // wsurl: 'wss://signal.remotemonster.com/ws',
    // resturl: 'https://signal.remotemonster.com/rest'
    // wsurl: 'wss://matiz.remotemonster.com/ws',
    // resturl: 'https://matiz.remotemonster.com/rest'
  },
  dev: {
    logLevel: 'DEBUG'
  }
  // logServer: {
  //   url: 'https://matiz.remotemonster.com:2001/topics'
  // }
}

export const remonDefaultConfigNextv = {
  credential: {
    key: '043ebf5d40a6d94428dfdb38b55c6cde637ab6b1be86b880',
    serviceId: 'minic77@etomato.com',
    // key: '1234567890',
    // serviceId: 'SERVICEID1',
    // key: 'testid',
    // serviceId: 'testid',
    // wsurl: 'ws://localhost:8081/ws',
    // resturl: 'http://localhost:8081/rest',
    // wsurl: 'wss://signal.remotemonster.com/ws',
    // resturl: 'https://signal.remotemonster.com/rest'
    wsurl: 'wss://matiz.remotemonster.com/ws',
    resturl: 'https://matiz.remotemonster.com/rest'
  },
  dev: {
    logLevel: 'DEBUG'
  },
  logServer: {
    url: 'https://matiz.remotemonster.com:2001/topics'
  }
}

export const remonDefaultConfig = (() => {
  return isNextv() ? remonDefaultConfigNextv : remonDefaultConfigTongtongpod
})()

export const quizBankApiServerUrlTongtongpod = 'https://us-central1-tongtongpod-3556c.cloudfunctions.net/widgets'
export const quizBankApiServerUrlNextv = 'https://us-central1-tomato-ddbce.cloudfunctions.net/widgets'

export const quizBankApiServerUrl = (() => {
  return isNextv() ? quizBankApiServerUrlNextv : quizBankApiServerUrlTongtongpod
})()

export const logServerUrlTongtongpod = 'https://us-central1-tongtongpod-3556c.cloudfunctions.net/log'
export const logServerUrlNextv = 'https://us-central1-tomato-ddbce.cloudfunctions.net/log'

export const logServerUrl = (() => {
  return isNextv() ? logServerUrlNextv : logServerUrlTongtongpod
})()

export const bannedWatchersUrlTongtongpod = 'https://admin.pod.otongtong.net/api/chatfiters'
export const bannedWatchersUrlNextv = 'https://us-central1-tomato-ddbce.cloudfunctions.net/api/chatfilters'

export const bannedWatchersUrl = (() => {
  return isNextv() ? bannedWatchersUrlNextv : bannedWatchersUrlTongtongpod
})()
